// Generated from LSEG Workspace's Excel add-in, Refinitiv for Office 26.30.2
// (resources/app.asar): for each of its 18 financial-contracts subtypes, the
// requiredUserDefinedParams and paramTypes of the subtype's processor config. IPA parameter
// names only, in LSEG's order and spelling (swaption keeps two names with a trailing space).
// Do not edit; regenerate with tools/gen_analytics_data.py.

export const ANALYTICS_DATA_VERSION = "26.30.2";

/** LSEG's FC subtypes (18), lower case. */
export type FcSubType = "bond" | "bondfuture" | "option" | "repo" | "termdeposit" | "voyageservice" | "swap" | "swaption" | "cds" | "fxcross" | "fxspot" | "fxforward" | "fxnondeliverableforward" | "fxswap" | "fxtimeoptionforward" | "multileg" | "fxforwardforward" | "capfloor";

export const FC_SUBTYPES: readonly FcSubType[] = ["bond", "bondfuture", "option", "repo", "termdeposit", "voyageservice", "swap", "swaption", "cds", "fxcross", "fxspot", "fxforward", "fxnondeliverableforward", "fxswap", "fxtimeoptionforward", "multileg", "fxforwardforward", "capfloor"];

export interface FcConfig {
  /** The user-defined params an instrument must carry, as LSEG spells them. */
  requiredUserDefinedParams: string[];
  /** Where each IPA parameter goes in the request: `instrumentDefinition`, `pricingParameters`, `marketData`. */
  paramTypes: Record<string, string[]>;
}

/** Per subtype; the fx* subtypes and multileg share LSEG's fxProcessorConfig; voyageservice has none. */
export const FC_CONFIGS: Record<FcSubType, FcConfig> = {
  bond: {
    requiredUserDefinedParams: ["FixedRatePercent", "IssueDate", "EndDate", "NotionalCcy", "InterestPaymentFrequency", "InterestCalculationMethod", "InterestType"],
    paramTypes: {
      instrumentDefinition: [
        "direction", "endDate", "fixedRatePercent", "indexFixingRic", "instrumentCode",
        "interestCalculationMethod", "interestPaymentFrequency", "interestType", "issueDate", "notionalCcy",
        "template", "accruedCalculationMethod", "adjustInterestToPaymentDate", "amortizationSchedule",
        "firstAccrualDate", "firstRegularPaymentDate", "fixedRatePercentSchedule", "floorStrikePercent",
        "indexCompoundingMethod", "indexFixingLag", "indexResetFrequency", "instrumentTag",
        "interestPaymentDelay", "isPerpetual", "lastRegularPaymentDate", "notionalAmount",
        "paymentBusinessDayConvention", "paymentBusinessDays", "paymentRollConvention", "spreadBp",
        "stubRule", "indexAverageMethod",
      ],
      pricingParameters: [
        "adjustedCleanPrice", "adjustedDirtyPrice", "adjustedYieldPercent", "applyTaxToFullPricing",
        "assetSwapSpreadBp", "benchmarkAtIssuePrice", "benchmarkAtIssueRic", "benchmarkAtIssueSpreadBp",
        "benchmarkAtIssueYieldPercent", "benchmarkAtRedemptionPrice", "benchmarkAtRedemptionSpreadBp",
        "benchmarkAtRedemptionYieldPercent", "benchmarkYieldSelectionMode", "bondRecoveryRatePercent",
        "cashAmount", "cdsRecoveryRatePercent", "cleanPrice", "computeCashFlowFromIssueDate",
        "computeCashFlowWithReportCcy", "concessionFee", "creditSpreadType", "currentYieldPercent",
        "dirtyPrice", "discountMarginBp", "discountPercent", "dividendType", "dividendYieldPercent",
        "edsfBenchmarkCurveYieldPercent", "edsfSpreadBp", "efpBenchmarkPrice", "efpBenchmarkRic",
        "efpBenchmarkYieldPercent", "efpSpreadBp", "flatCreditSpreadBp", "flatCreditSpreadTenor",
        "fxPriceSide", "fxStockCorrelation", "fxVolatilityPercent", "fxVolatilityTenor",
        "govCountryBenchmarkCurvePrice", "govCountryBenchmarkCurveYieldPercent", "govCountrySpreadBp",
        "governmentBenchmarkCurvePrice", "governmentBenchmarkCurveYieldPercent", "governmentSpreadBp",
        "inflationMode", "issuerBenchmarkCurveYieldPercent", "issuerSpreadBp", "marketDataDate",
        "marketValueInDealCcy", "marketValueInReportCcy", "netPrice", "neutralYieldPercent",
        "oisZcBenchmarkCurveYieldPercent", "oisZcSpreadBp", "optionAdjustedSpreadBp", "price", "priceSide",
        "priceSides", "yieldPercentArrayTypes", "projectedIndexCalculationMethod", "projectedIndexPercent",
        "quotedPrice", "quoteFallbackLogic", "ratingBenchmarkCurveYieldPercent", "ratingSpreadBp",
        "redemptionDate", "redemptionDateType", "reportCcy", "roundingParameters",
        "sectorRatingBenchmarkCurveYieldPercent", "sectorRatingSpreadBp", "settlementConvention",
        "simpleMarginBp", "stockBorrowRatePercent", "stockFlatVolatilityPercent", "stockFlatVolatilityTenor",
        "stockPriceOnDefault", "stripYieldPercent", "swapBenchmarkCurveYieldPercent", "swapSpreadBp",
        "taxOnCapitalGainPercent", "taxOnCouponPercent", "taxOnPricePercent", "taxOnYieldPercent",
        "tradeDate", "userDefinedBenchmarkPrice", "userDefinedBenchmarkYieldPercent", "userDefinedSpreadBp",
        "useSettlementDateFromQuote", "valuationDate", "volatilityTermStructureType", "volatilityType",
        "yieldPercent", "yieldType", "zSpreadBp", "nextCouponRatePercent",
      ],
    },
  },
  bondfuture: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentCode", "notionalAmount", "underlyingInstruments", "instrumentTag",
        "accruedCalculationMethod", "adjustInterestToPaymentDate", "amortizationSchedule", "direction",
        "endDate", "firstAccrualDate", "firstRegularPaymentDate", "fixedRatePercent",
        "fixedRatePercentSchedule", "floorStrikePercent", "indexCompoundingMethod", "indexFixingLag",
        "indexFixingRic", "indexResetFrequency", "interestCalculationMethod", "interestPaymentDelay",
        "interestPaymentFrequency", "interestType", "isPerpetual", "issueDate", "lastRegularPaymentDate",
        "notionalCcy", "paymentBusinessDayConvention", "paymentBusinessDays", "paymentRollConvention",
        "spreadBp", "stubRule", "template",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "reportCcy", "priceSide", "price", "marketValueInDealCcy",
        "marketValueInReportCcy", "repoRatePercent", "adjustedCleanPrice", "adjustedDirtyPrice",
        "adjustedYieldPercent", "applyTaxToFullPricing", "assetSwapSpreadBp", "benchmarkAtIssuePrice",
        "benchmarkAtIssueRic", "benchmarkAtIssueSpreadBp", "benchmarkAtIssueYieldPercent",
        "benchmarkAtRedemptionPrice", "benchmarkAtRedemptionSpreadBp", "benchmarkAtRedemptionYieldPercent",
        "benchmarkYieldSelectionMode", "bondRecoveryRatePercent", "cashAmount", "cdsRecoveryRatePercent",
        "cleanPrice", "computeCashFlowFromIssueDate", "computeCashFlowWithReportCcy", "concessionFee",
        "creditSpreadType", "currentYieldPercent", "deliveryStartDate", "dirtyPrice", "discountMarginBp",
        "discountPercent", "dividendType", "dividendYieldPercent", "edsfBenchmarkCurveYieldPercent",
        "edsfSpreadBp", "efpBenchmarkPrice", "efpBenchmarkRic", "efpBenchmarkYieldPercent", "efpSpreadBp",
        "flatCreditSpreadBp", "flatCreditSpreadTenor", "fxPriceSide", "fxStockCorrelation",
        "fxVolatilityPercent", "fxVolatilityTenor", "govCountryBenchmarkCurvePrice",
        "govCountryBenchmarkCurveYieldPercent", "govCountrySpreadBp", "governmentBenchmarkCurvePrice",
        "governmentBenchmarkCurveYieldPercent", "governmentSpreadBp", "inflationMode",
        "issuerBenchmarkCurveYieldPercent", "issuerSpreadBp", "netPrice", "neutralYieldPercent",
        "oisZcBenchmarkCurveYieldPercent", "oisZcSpreadBp", "optionAdjustedSpreadBp",
        "projectedIndexCalculationMethod", "projectedIndexPercent", "quotedPrice", "quoteFallbackLogic",
        "ratingBenchmarkCurveYieldPercent", "ratingSpreadBp", "redemptionDate", "redemptionDateType",
        "roundingParameters", "sectorRatingBenchmarkCurveYieldPercent", "sectorRatingSpreadBp",
        "settlementConvention", "simpleMarginBp", "stockBorrowRatePercent", "stockFlatVolatilityPercent",
        "stockFlatVolatilityTenor", "stockPriceOnDefault", "stripYieldPercent",
        "swapBenchmarkCurveYieldPercent", "swapSpreadBp", "taxOnCapitalGainPercent", "taxOnCouponPercent",
        "taxOnPricePercent", "taxOnYieldPercent", "tradeDate", "userDefinedBenchmarkPrice",
        "userDefinedBenchmarkYieldPercent", "userDefinedSpreadBp", "useSettlementDateFromQuote",
        "volatilityTermStructureType", "volatilityType", "yieldPercent", "yieldType", "zSpreadBp",
      ],
    },
  },
  option: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "strike", "buySell", "callPut", "endDate", "underlyingType", "exerciseStyle",
        "underlyingDefinition", "asianDefinition", "barrierDefinition", "doubleBarrierDefinition",
        "binaryDefinition", "doubleBinaryDefinition", "cbbcDefinition", "instrumentCode", "lotSize",
        "dealContract", "tenor", "deliveryDate", "notionalAmount", "notionalCcy", "forwardStartDefinition",
        "dualCurrencyDefinition", "endDateTime", "offset", "payments", "doubleBarriersDefinition",
        "timeZoneOffset", "settlementCcy", "settlementType", "startDate",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "reportCcy", "reportCcyRate", "marketValueInDealCcy",
        "pricingModelType", "payoutCustomDates", "dividendType", "dividendYieldPercent", "volatilityPercent",
        "riskFreeRatePercent", "underlyingPrice", "volatilityType", "optionPriceSide", "optionTimeStamp",
        "underlyingPriceSide", "underlyingTimeStamp", "priceSide", "volatilityModel",
        "fxSwapCalculationMethod", "fxSpotObject", "atmVolatilityObject", "riskReversal10DObject",
        "riskReversal25DObject", "butterfly10DObject", "butterfly25DObject", "forwardPointsObject",
        "domesticDepositRatePercentObject", "impliedVolatilityObject", "cutoffTimeZone", "cutoffTime",
        "payoutScalingInterval", "marketValueInReportCcy", "foreignDepositRatePercentObject",
        "interpolationWeight", "computeVolatilityPayout", "computePayoutChart", "simulateExercise",
        "volatility",
      ],
    },
  },
  repo: {
    requiredUserDefinedParams: ["underlyingInstruments"],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "startDate", "endDate", "tenor", "isCouponExchanged", "repoRatePercent",
        "dayCountBasis", "underlyingInstruments",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "settlementConvention", "couponReinvestmentRatePercent",
        "repoCurveType", "reportCcy",
      ],
    },
  },
  termdeposit: {
    requiredUserDefinedParams: ["NotionalCcy", "FixedRatePercent"],
    paramTypes: {
      instrumentDefinition: [
        "instrumentCode", "notionalAmount", "notionalCcy", "fixedRatePercent", "startDate", "endDate",
        "tenor", "yearBasis", "instrumentTag", "calendar", "paymentRollConvention",
        "paymentBusinessDayConvention",
      ],
      pricingParameters: [
        "incomeTaxPercent", "priceSide", "valuationDate", "marketDataDate", "reportCcy",
      ],
    },
  },
  voyageservice: { requiredUserDefinedParams: [], paramTypes: {} },
  swap: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "tradeDate", "startDate", "endDate", "tenor", "settlementCcy", "isNonDeliverable",
        "instrumentCode", "template", "legs", "startTenor",
      ],
      pricingParameters: [
        "discountingCcy", "valuationDate", "reportCcy", "marketDataDate", "marketValueInDealCcy",
        "indexConvexityAdjustmentMethod", "indexConvexityAdjustmentIntegrationMethod", "useCurveBuilder",
        "discountingTenor", "priceSide", "tenorReferenceDate",
      ],
    },
  },
  swaption: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "settlementType", "endDate", "tenor", "notionalAmount ", "strikePercent ",
        "buySell", "callPut", "exerciseStyle", "underlyingDefinition", "bermudanSwaptionDefinition",
        "swaptionType", "instrumentCode", "isNonDeliverable", "legs", "notionalAmount", "payments",
        "premiumSettlementType", "settlementCcy", "spreadVsAtmInBp", "startDate", "startTenor",
        "strikePercent", "template", "tradeDate",
      ],
      pricingParameters: [
        "valuationDate", "reportCcy", "marketValueInDealCcy", "nbIterations", "marketDataDate",
        "discountingCcy", "discountingTenor", "exerciseDate", "indexConvexityAdjustmentIntegrationMethod",
        "indexConvexityAdjustmentMethod", "priceSide", "simulateExercise", "tenorReferenceDate",
      ],
      marketData: [
        "interestRateVolatilitySurfaces", "hullWhiteCurves", "interestRateCurves",
      ],
    },
  },
  cds: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "instrumentCode", "startDate", "stepInDate", "endDate", "tenor", "tradeDate",
        "startDateMovingConvention", "endDateMovingConvention", "adjustToIsdaEndDate", "protectionLeg",
        "premiumLeg", "cdsConvention", "accruedBeginDate",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "reportCcy", "upfrontAmountInDealCcy", "upfrontPercent",
        "cleanPricePercent", "conventionalSpreadBp", "cashAmountInDealCcy",
      ],
    },
  },
  fxcross: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "fxCrossCode", "fxCrossType", "tradedCrossRate", "tradedSwapPoints",
        "referenceSpotRate", "ndfFixingSettlementCcy", "legs",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "ignoreRefCcyHolidays", "reportCcy", "fxSwapCalculationMethod",
        "priceSide", "depositCcy1", "depositCcy2", "isIntraday", "adjustAllDepositPointsToCrossCalendars",
        "adjustAllSwapPointsToCrossCalendars", "calcEndFromFwdStart", "calcEndFromPreSpotStart",
        "oneDayValues", "spreadMarginInBp", "fxSwapsCcy1", "fxSwapsCcy2", "fxSwapsCcy1Ccy2",
        "fxSwapsNearLeg", "fxSwapsFarLeg",
      ],
      marketData: [
        "fxSwapPoints", "depositCurves", "fxSpots", "timestamp",
      ],
    },
  },
  fxspot: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "fxCrossCode", "fxCrossType", "tradedCrossRate", "tradedSwapPoints",
        "referenceSpotRate", "ndfFixingSettlementCcy", "legs",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "ignoreRefCcyHolidays", "reportCcy", "fxSwapCalculationMethod",
        "priceSide", "depositCcy1", "depositCcy2", "isIntraday", "adjustAllDepositPointsToCrossCalendars",
        "adjustAllSwapPointsToCrossCalendars", "calcEndFromFwdStart", "calcEndFromPreSpotStart",
        "oneDayValues", "spreadMarginInBp", "fxSwapsCcy1", "fxSwapsCcy2", "fxSwapsCcy1Ccy2",
        "fxSwapsNearLeg", "fxSwapsFarLeg",
      ],
      marketData: [
        "fxSwapPoints", "depositCurves", "fxSpots", "timestamp",
      ],
    },
  },
  fxforward: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "fxCrossCode", "fxCrossType", "tradedCrossRate", "tradedSwapPoints",
        "referenceSpotRate", "ndfFixingSettlementCcy", "legs",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "ignoreRefCcyHolidays", "reportCcy", "fxSwapCalculationMethod",
        "priceSide", "depositCcy1", "depositCcy2", "isIntraday", "adjustAllDepositPointsToCrossCalendars",
        "adjustAllSwapPointsToCrossCalendars", "calcEndFromFwdStart", "calcEndFromPreSpotStart",
        "oneDayValues", "spreadMarginInBp", "fxSwapsCcy1", "fxSwapsCcy2", "fxSwapsCcy1Ccy2",
        "fxSwapsNearLeg", "fxSwapsFarLeg",
      ],
      marketData: [
        "fxSwapPoints", "depositCurves", "fxSpots", "timestamp",
      ],
    },
  },
  fxnondeliverableforward: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "fxCrossCode", "fxCrossType", "tradedCrossRate", "tradedSwapPoints",
        "referenceSpotRate", "ndfFixingSettlementCcy", "legs",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "ignoreRefCcyHolidays", "reportCcy", "fxSwapCalculationMethod",
        "priceSide", "depositCcy1", "depositCcy2", "isIntraday", "adjustAllDepositPointsToCrossCalendars",
        "adjustAllSwapPointsToCrossCalendars", "calcEndFromFwdStart", "calcEndFromPreSpotStart",
        "oneDayValues", "spreadMarginInBp", "fxSwapsCcy1", "fxSwapsCcy2", "fxSwapsCcy1Ccy2",
        "fxSwapsNearLeg", "fxSwapsFarLeg",
      ],
      marketData: [
        "fxSwapPoints", "depositCurves", "fxSpots", "timestamp",
      ],
    },
  },
  fxswap: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "fxCrossCode", "fxCrossType", "tradedCrossRate", "tradedSwapPoints",
        "referenceSpotRate", "ndfFixingSettlementCcy", "legs",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "ignoreRefCcyHolidays", "reportCcy", "fxSwapCalculationMethod",
        "priceSide", "depositCcy1", "depositCcy2", "isIntraday", "adjustAllDepositPointsToCrossCalendars",
        "adjustAllSwapPointsToCrossCalendars", "calcEndFromFwdStart", "calcEndFromPreSpotStart",
        "oneDayValues", "spreadMarginInBp", "fxSwapsCcy1", "fxSwapsCcy2", "fxSwapsCcy1Ccy2",
        "fxSwapsNearLeg", "fxSwapsFarLeg",
      ],
      marketData: [
        "fxSwapPoints", "depositCurves", "fxSpots", "timestamp",
      ],
    },
  },
  fxtimeoptionforward: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "fxCrossCode", "fxCrossType", "tradedCrossRate", "tradedSwapPoints",
        "referenceSpotRate", "ndfFixingSettlementCcy", "legs",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "ignoreRefCcyHolidays", "reportCcy", "fxSwapCalculationMethod",
        "priceSide", "depositCcy1", "depositCcy2", "isIntraday", "adjustAllDepositPointsToCrossCalendars",
        "adjustAllSwapPointsToCrossCalendars", "calcEndFromFwdStart", "calcEndFromPreSpotStart",
        "oneDayValues", "spreadMarginInBp", "fxSwapsCcy1", "fxSwapsCcy2", "fxSwapsCcy1Ccy2",
        "fxSwapsNearLeg", "fxSwapsFarLeg",
      ],
      marketData: [
        "fxSwapPoints", "depositCurves", "fxSpots", "timestamp",
      ],
    },
  },
  multileg: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "fxCrossCode", "fxCrossType", "tradedCrossRate", "tradedSwapPoints",
        "referenceSpotRate", "ndfFixingSettlementCcy", "legs",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "ignoreRefCcyHolidays", "reportCcy", "fxSwapCalculationMethod",
        "priceSide", "depositCcy1", "depositCcy2", "isIntraday", "adjustAllDepositPointsToCrossCalendars",
        "adjustAllSwapPointsToCrossCalendars", "calcEndFromFwdStart", "calcEndFromPreSpotStart",
        "oneDayValues", "spreadMarginInBp", "fxSwapsCcy1", "fxSwapsCcy2", "fxSwapsCcy1Ccy2",
        "fxSwapsNearLeg", "fxSwapsFarLeg",
      ],
      marketData: [
        "fxSwapPoints", "depositCurves", "fxSpots", "timestamp",
      ],
    },
  },
  fxforwardforward: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "fxCrossCode", "fxCrossType", "tradedCrossRate", "tradedSwapPoints",
        "referenceSpotRate", "ndfFixingSettlementCcy", "legs",
      ],
      pricingParameters: [
        "valuationDate", "marketDataDate", "ignoreRefCcyHolidays", "reportCcy", "fxSwapCalculationMethod",
        "priceSide", "depositCcy1", "depositCcy2", "isIntraday", "adjustAllDepositPointsToCrossCalendars",
        "adjustAllSwapPointsToCrossCalendars", "calcEndFromFwdStart", "calcEndFromPreSpotStart",
        "oneDayValues", "spreadMarginInBp", "fxSwapsCcy1", "fxSwapsCcy2", "fxSwapsCcy1Ccy2",
        "fxSwapsNearLeg", "fxSwapsFarLeg",
      ],
      marketData: [
        "fxSwapPoints", "depositCurves", "fxSpots", "timestamp",
      ],
    },
  },
  capfloor: {
    requiredUserDefinedParams: [],
    paramTypes: {
      instrumentDefinition: [
        "instrumentTag", "notionalCcy", "startDate", "endDate", "tenor", "notionalAmount", "indexName",
        "indexFixingRic", "indexTenor", "interestCalculationMethod", "indexResetFrequency", "indexResetType",
        "interestPaymentFrequency", "paymentBusinessDayConvention", "paymentRollConvention", "stubRule",
        "adjustInterestToPaymentDate", "indexFixingLag", "buySell", "capStrikePercent", "floorStrikePercent",
        "capStrikePercentSchedule", "floorStrikePercentSchedule", "amortizationSchedule", "cmsTemplate",
        "paymentBusinessDays", "annualizedRebate", "capDigitalPayoutPercent", "floorDigitalPayoutPercent",
        "barrierDefinition", "interestCalculationConvention", "isBackwardLookingIndex", "payments",
      ],
      pricingParameters: [
        "skipFirstCapFloorlet", "marketValueInDealCcy", "valuationDate", "marketDataDate", "reportCcy",
        "indexConvexityAdjustmentMethod", "indexConvexityAdjustmentIntegrationMethod", "priceSide",
      ],
    },
  },
};
